export default __webpack_public_path__ + "static/media/Logo.b84f2934.png";